import { Typography, Container, Grid } from "@mui/material";
import successImage from "../../../assets/Images/success.png";

const SubmitSuccessPage = () => {
  return (
    <Grid sx={{ mt: "12rem" }}>
      <Grid display={"flex"} alignItems="center" justifyContent="center">
        <img
          src={successImage}
          alt="Success"
          style={{ maxWidth: "10rem", height: "auto" }}
        />
      </Grid>
      <Container maxWidth="md">
        <Grid
          container
          spacing={3}
          alignItems="center"
          justifyContent="center"
          mt={"10px"}
        >
          <Grid item xs={12} sm={12}>
            <Typography variant="h4" align="center" gutterBottom>
              Referral Submitted Successfully
            </Typography>
            <Typography variant="body1" align="center" paragraph>
              We have sent you a confirmation message for submission of this
              referral. Please check your spam folder if you do not receive this
              in the primary inbox. We also sent an account activation email to
              the parent email provided in the referral form, please let the
              parent know to check their spam folder in case they do not receive
              the account setup email in their primary inbox.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
};

export default SubmitSuccessPage;
